import PriceItem, { PriceItemProps } from './PriceItem';

export type { PriceItemProps };
export default PriceItem;
